import Backdrop from "@mui/material/Backdrop";
import Modal from "@mui/material/Modal";
import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  ClearImage,
  setBatchUrlImage,
  setCurrentIndex,
  setFirst,
} from "../../Redux/MainImage/imageSlice";
import { useEffect } from "react";
import { CircularProgressbar } from "react-circular-progressbar";
import { useTranslation } from "react-i18next";
import "../../Assets/Styles/pages/uploadImage.scss";
import { setBatchDownload } from "../../Redux/UserSlice/userSlice";
import { deleteAll } from "../../Redux/WaterMarks/wateramarks";
import processingImg from "../../Assets/Images/processingModalImage.jpg";
import verticalAd from "../../Assets/Images/veritcalAd.jpg";

const DownloadBatch = ({ open, setOpen, urls, setUrls, setBatchStarted }) => {
  const [index, setIndex] = useState(0);
  const [totalIndex, setTotalIndex] = useState(0);
  const [completed, setCompleted] = useState(false);

  const { t } = useTranslation();
  const dispatch = useDispatch();

  //reading main image from store
  const file = useSelector((state) => state.mainImage);
  const mainImageState = useSelector((state) => state["mainImage"]);
  const downloadState = useSelector((state) => state["downloadSlice"]);
  const userSliceState = useSelector((state) => state["userSlice"]);

  useEffect(() => {
    setIndex(mainImageState.currentIndex);
    setTotalIndex(mainImageState.batchurls.length);
  }, [mainImageState.currentIndex]);

  useEffect(() => {
    if (open) {
      dispatch(setCurrentIndex(0));
      setBatchStarted(true);
    }
  }, [open]);

  useEffect(() => {
    const effectFunc = async () => {
      if (userSliceState.online) {
        if (file.batchurls.length) {
          if (
            open &&
            !downloadState.Create &&
            mainImageState.currentIndex < file.batchurls.length
          ) {
            dispatch(setBatchDownload(true));

            var cIndex = 0;
            if (!mainImageState.first) cIndex = mainImageState.currentIndex;
            dispatch(setBatchUrlImage(cIndex));
            dispatch(setFirst(false));
          } else if (
            mainImageState.currentIndex >= file.batchurls.length &&
            open &&
            !completed // Check if the download is not completed
          ) {
            handleDownloadZip(urls, setOpen);
          }
          if (!open && !(mainImageState.currentIndex < file.batchurls.length)) {
            updateReduxStateInBackground();
          }
        }
      }
    };

    effectFunc();
  }, [open, urls, userSliceState.online, completed]);

  const updateReduxStateInBackground = () =>
    new Promise((resolve, reject) => {
      try {
        dispatch(setBatchDownload(false));
        dispatch(setBatchUrlImage(0));
        dispatch(ClearImage());
        dispatch(deleteAll());
        resolve("Redux state updated successfully");
      } catch (error) {
        reject(error);
      }
    });

  const handleDownloadZip = async (dataUrls, setOpen) => {
    setCompleted(true);
    // const zip = new JSZip();

    // dataUrls.forEach((dataUrl, index) => {
    //   const fileData = dataUrl.file;
    //   zip.file(index + dataUrl.name, fileData);
    // });

    // const content = await zip.generateAsync({ type: "blob" });

    // saveAs(content, "files.zip");

    //////
    setOpen(false);
    setCompleted(true);
    setUrls([]);
  };

  return (
    <Modal
      open={open}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 800,
      }}
    >
      <Row
        style={{ width: "50vw" }}
        className="model justify-content-between align-items-center m-0 p-3 py-4"
      >
        <Col xs={2} className="d-flex justify-content-start p-0 m-0">
          <img src={verticalAd} alt="Left ad" />
        </Col>
        <Col xs={8}>
          <img className="w-100" src={processingImg} alt="Processing" />
          <Row className="cloudbg d-flex justify-content-center">
            <Row className="w-25 d-flex justify-content-center align-items-center">
              <CircularProgressbar
                className="px-3 h-50"
                minValue={0}
                value={index}
                maxValue={totalIndex}
                // text={`${index}/${totalIndex}`}
                styles={{
                  root: {},
                  path: {
                    stroke: `#F15C6A`,
                    strokeLinecap: "butt",
                    transition: "stroke-dashoffset 0.5s ease 0s",
                    transform: "rotate(0turn)",
                    transformOrigin: "center center",
                  },
                  trail: {
                    stroke: "#F9B4BA",
                    strokeLinecap: "butt",
                    transform: "rotate(0.25turn)",
                    transformOrigin: "center center",
                  },
                  text: {
                    fill: "rgba(241, 92, 106, 1)",
                    fontSize: "16px",
                    textAlign: "center",
                  },
                }}
              />
            </Row>
            <Row className="d-flex justify-content-center Aktiv_Medium text_20">
              {index + "/" + totalIndex + t("Watermarked")}
            </Row>
            <Row className="d-flex justify-content-center Aktiv text_13 mb-4 text-center">
              {t(
                completed && file.ImageCanvasExceeded
                  ? "WatermarkedDescriptionCompleted"
                  : "WatermarkedDescription"
              )}
            </Row>
          </Row>
        </Col>
        <Col xs={2} className="d-flex justify-content-end p-0 m-0">
          <img src={verticalAd} alt="Right ad" />
        </Col>
      </Row>
    </Modal>
  );
};

export default DownloadBatch;
